import React, {FC, memo} from "react";
import {Button, Modal, Space, Tag} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {GetBookingByIdQuery, GetBookingByIdWithCourseLessonBookingsQuery} from "../../generated/graphql";
import {RenderAmount} from "../TableColumnRenderers/TableColumnRenderers";
import {marginXs} from "../../styles/layout";

type PossibleBookingType =
    | GetBookingByIdQuery["bookingById"]
    | GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"];

type BookingDiscountDisplayProps = {
    booking?: PossibleBookingType;
};

const BookingDiscountDisplay: FC<BookingDiscountDisplayProps> = ({booking}) => {
    const discount = booking?.discount;
    const discountName = booking?.discountName;

    if (!discount) {
        return null;
    }

    const label = discountName || "Rabatt";

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: `calc(${marginXs} * -1)`,
                marginBottom: marginXs,
            }}
        >
            <Button
                type="text"
                style={{paddingRight: marginXs}}
                onClick={() =>
                    Modal.info({
                        icon: null,
                        okButtonProps: {block: true},
                        content: (
                            <p style={{textAlign: "center"}}>
                                {`Auf diese Buchung wurde ein Rabatt "${label}" angewendet.`}
                            </p>
                        ),
                    })
                }
            >
                <InfoCircleOutlined style={{color: "green"}} />
                <Tag color="green">
                    <Space size={5}>
                        <span>{label}</span>
                        <RenderAmount amount={discount} style={{fontSize: "unset", fontWeight: 600}} />
                    </Space>
                </Tag>
            </Button>
        </div>
    );
};

export default memo(BookingDiscountDisplay);
